import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
// Import fonts
import '../assets/fonts/fonts.css';
// Import themes
import cudaLight from './themes/cudaLight';
import baseMui from './themes/baseMui';
export default function BDSProvider({ children, useBdsTheme = true, useCssReset = true, selectedBdsTheme = 'baseMui', // Default to BaseMui if no theme is selected
themeConfig = {}, fontFamilyOverride = '' }) {
    let theme = {};
    if (useBdsTheme) {
        theme = (selectedBdsTheme === 'baseMui' ? baseMui : cudaLight);
    }
    const typography = Object.assign(Object.assign({}, (theme.typography || {})), { fontFamily: fontFamilyOverride || (theme.typography ? theme.typography.fontFamily : 'Roboto, sans-serif') // Default will get changed to a token
     });
    theme = Object.assign(Object.assign(Object.assign({}, theme), { typography }), themeConfig);
    return (React.createElement(ThemeProvider, { theme: theme },
        useCssReset ? React.createElement(CssBaseline, null) : null,
        children));
}
//# sourceMappingURL=BDSProvider.js.map